import { Http, Response } from '@angular/http';
import { Observable, Subject } from 'rxjs';

import { CompleterData, CompleterItem } from 'ng2-completer';

export class CustomCompleterData extends Subject<CompleterItem[]> implements CompleterData {
    private items: Array<any>;
    constructor(source: Observable<Array<any>>, private titleField: string) {
        super();

        source.subscribe(value => {
            this.items = value;
        });
    }

    public search(term: string): void {
        var filtered = this.items.filter((row) => {
            return (row[this.titleField] != null && <string>(row[this.titleField]).toLowerCase().includes(term.toLowerCase()));
        }).map(item => <CompleterItem>{
            title: item[this.titleField],
            originalObject: item
        });

        this.next(filtered);
    }

    public hasItems() {
        return this.items != null && this.items.length > 0;
    }

    public cancel() {
        // Handle cancel
    }
}



// WEBPACK FOOTER //
// ./Angular/app/_helpers/custom-completer-data.ts